import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent } from 'src/app/components/common/modal/modal.component';

@Component({
  selector: 'app-experienced-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe, ModalComponent],
  templateUrl: './experienced-dialog.component.html',
  styleUrl: './experienced-dialog.component.scss',
})
export class ExperiencedDialogComponent {
  constructor(public activeModal: NgbActiveModal) {}

  protected handlePrimaryAction() {
    this.activeModal.close(true);
  }

  protected handleSecondaryAction() {
    this.activeModal.close(false);
  }
}
